const styles = (theme) => ({
  tableContent: {
    backgroundColor: "#0e938e",
    borderRadius: "20px",
    padding: "10px",
  },
  start: {
    backgroundColor: "#001a5b !important",
    cursor: "pointer",
    color: "#ffffff !important",
    "&:hover": {
      background: "#80cbe3 !important",
    },
  },
  empty: {
    backgroundColor: "#076662 !important",
  },
  selected: {
    backgroundColor: "#80cbe3 !important",
  },
  table: {
    borderCollapse: "collapse",
  },
  td: {
    width: "32px",
    height: "32px",
    border: "5px solid #0e938e",
    textAlign: "center",
    position: "relative",
    textTransform: "uppercase",
    backgroundColor: "#fff",
    borderRadius: "20px",
    color: "#000",
    fontSize: "14px",
    [theme.breakpoints.up(1023)]: {
      width: "55px",
      height: "55px",
      fontSize: "30px",
    },
  },
  answer: {
    width: "80px",
    height: "80px",
    textAlign: "center",
    borderRadius: "15px",
    textTransform: "uppercase",
    color: "#ffffff !important",
    backgroundColor: "#001a5b !important",
    fontSize: "30px",
  },
  inputbase: {
    backgroundColor: "#d8d8d8",
    width: "100%",
    borderRadius: "10px",
    color: "#000",
    margin: 0,
    marginTop: "5px",
    marginBottom: "10px",
    font: "inherit",
    border: 0,
    display: "block",
    padding: "6px 0 7px",
    minWidth: 0,
    background: "none",
    boxSizing: "content-box",
    animationName: "mui-auto-fill-cancel",
    letterSpacing: "inherit",
    webkitTapHighlightColor: "transparent",
  },
});

export default styles;
